import { useMutation, useQueryClient } from '@tanstack/vue-query';

import { acceptInvitation, declineInvitation, inviteUser, revokeInvitation } from '../api';
import { handleCurrentUserInvitationSuccess } from './handlers/handleCurrentUserInvitationSuccess';
import { handleInvitationSuccess } from './handlers/handleInvitationSuccess';

export const useInviteUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: inviteUser,
    onSuccess: handleInvitationSuccess(queryClient),
  });
};

export const useRevokeInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: revokeInvitation,
    onSuccess: handleInvitationSuccess(queryClient),
  });
};

export const useAcceptInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: acceptInvitation,
    onSuccess: handleCurrentUserInvitationSuccess(queryClient),
  });
};

export const useDeclineInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: declineInvitation,
    onSuccess: handleCurrentUserInvitationSuccess(queryClient),
  });
};
